import { render, staticRenderFns } from "./QuickNotificationItem.vue?vue&type=template&id=14d8e444&scoped=true"
import script from "./QuickNotificationItem.vue?vue&type=script&lang=js"
export * from "./QuickNotificationItem.vue?vue&type=script&lang=js"
import style0 from "./QuickNotificationItem.vue?vue&type=style&index=0&id=14d8e444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d8e444",
  null
  
)

export default component.exports